// ── V158: 영수증 사진 줄이기 ─────────────────────────────────────────────────────
// 입고 영수증 사진은 Firestore 문서(1MB 한도)에 그대로 넣는다 — 중국에서도 같은 길(/__fb)로 오가고,
// Storage 규칙을 바꾸지 않아도 직원(매니저) 계정이 올릴 수 있다.
// 긴 변 1400px · JPEG, 글자 수가 PHOTO_MAX_CHARS 아래가 될 때까지 화질·크기를 낮춘다.
import { fileToDataUrl } from './ocr';

export const PHOTO_MAX_CHARS = 700000;   // base64 약 510KB
const STEPS = [
  [1400, 0.8], [1400, 0.68], [1200, 0.62], [1024, 0.58], [900, 0.52], [760, 0.5], [640, 0.45],
];

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error('image'));
    i.src = src;
  });
}

/** File → { data: 'data:image/jpeg;base64,…', w, h, bytes } */
export async function compressReceiptPhoto(file, maxChars = PHOTO_MAX_CHARS) {
  if (!file) throw new Error('file');
  const src = await fileToDataUrl(file);
  const img = await loadImage(src);
  const W = img.naturalWidth || img.width;
  const H = img.naturalHeight || img.height;
  if (!(W > 0 && H > 0)) throw new Error('image');
  let last = null;
  for (const [maxDim, q] of STEPS) {
    const ratio = Math.min(1, maxDim / Math.max(W, H));
    const w = Math.max(1, Math.round(W * ratio));
    const h = Math.max(1, Math.round(H * ratio));
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);
    const data = canvas.toDataURL('image/jpeg', q);
    last = { data, w, h, bytes: Math.round(data.length * 0.75) };
    if (data.length <= maxChars) return last;
  }
  if (last && last.data.length <= maxChars * 1.3) return last;
  throw new Error('too-big');
}
